module.exports = __webpack_public_path__ + "static/img/langChange.6908dfb3.svg";